import React, { Component } from "react";
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../generics/WaitingModal';
import SearchBar from '../generics/SearchBar';
import swal from 'sweetalert';
import TableWorkList from './components/TableWorkList';
import RaisedButton from 'material-ui/RaisedButton';
import ModalSection from './components/ModalSection';
import Help from '../generics/help';
import moment from 'moment';

var Config = require('../../config');

const style = {
  margin: 7,
};

class WorkList extends Component {
  constructor(props, context) {
    super(props);

    this.cancel = this.cancel.bind(this);
    this.saveItem = this.saveItem.bind(this);
    this.getSections  = this.getSections.bind(this);
    this.selectSection = this.selectSection.bind(this);
    this.openModalSection = this.openModalSection.bind(this);
    this.handleChange = this.handleChange.bind(this);

    var aux_date = new Date();
    //Definicion de variables
    this.state = {
      start_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
      end_date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
      filterText:"",
      items:[],
      filter_type:"pending",
      filters:[{key:"all", value:"TODOS"}, {key:"pending",value:"RESULTADOS PENDIENTES"}, {key:"rejected",value:"RECHAZADOS"}],
      start_folio:"",
      end_folio:"",
      lab_sections_id:"",
      lab_sections:[],
      convoke_places:[], 
      convoke_places_id:"all",
      select_section:true,
    };
  }

  componentDidMount() {
    this.openModalSection();

    fetch(Config.default.apiGateway.URL+'convoke_places?option=active&health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
      method: 'get',
      headers: new Headers({
         'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
         'Accept': 'application/json',
          'Content-Type': 'application/json',
      })
    })
    .then(res => {
          if(res.ok){
            return res.json();
          }else{
            res.text().then(function(result) {
              swal('¡Error', result, 'error');
            });
        }})
    .then(response => {
      this.setState({
          convoke_places: response
        });
    })
  }

  openModalSection(){
    this.waiting_modal.handleShow('Cargando...');
    fetch(Config.default.apiGateway.URL+'lab_sections/byUser?health_facilities_id='+sessionStorage.getItem("health_facilities_id"), {
      method : 'get',
      headers: new Headers({
        'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
        'Accept'        : 'application/json',
        'Content-Type'  : 'application/json'
      })
    })
    .then(res => {
      this.waiting_modal.handleClose();
        if(res.ok){
          return res.json();
        }else{
          res.text().then(function(error) {
            swal('¡Error!', error, 'error');
          });
      }
    }).then(response => {
      if(response.length == 0){
          
        swal({
          title: "Error", 
          text: "No se encontraron secciones.", 
          type: "error",
          closeOnConfirm: true,
          confirmButtonText: "OK",
        }, function() {
          this.props.history.push("/");
        }.bind(this));
        
      
      }else if(response.length == 1){
        this.setState({
          lab_sections: response
        })
        this.getSections(response[0].lab_sections_id);

      }else{
        this.setState({
          lab_sections: response
        });

       

      }
    })
  }

  handleChange(event){
    var value = event.target.value;
    this.setState({[event.target.name]: event.target.value});

    if(event.target.name === 'section'){
      setTimeout(()=>{
        this.getSections(value);
      }, 500)
    }
    
  }

  handleUserInput(filterText) {
    this.setState({filterText: filterText});
  };


  saveItem(){
    var sample = this.table.getResults();
    var url = 'samples';
    if(this.props.location.pathname === '/work_list/patient'){
      url = 'sample_results/save_patients_results'
    }
    if(sample.length > 0){
      this.waiting_modal.handleShow('Guardando...');
      fetch(Config.default.apiGateway.URL+url, {
        method : 'POST',
        body   : JSON.stringify(sample),
        headers: new Headers({
          'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
          'Accept'        : 'application/json',
          'Content-Type'  : 'application/json'
        })
      })
      .then(res => {
        this.waiting_modal.handleClose();
          if(res.ok){
            return res.json();
          }else{
            res.text().then(function(error) {
              swal('¡Error!', error, 'error');
            });
        }
      })
      .then(response => {
        
        setTimeout(function(){
          this.waiting_modal.handleClose();
          this.getSections(this.lab_sections_id);

        }.bind(this), 1000);
          
      });

    }

  }

  getSections(num){
    var patient = false; 
    if(this.props.location.pathname === '/work_list/patient'){
      patient = true;
    }

    if(num === undefined){
      num = this.state.lab_sections_id;
    }else{
      this.setState({
        lab_sections_id: num
      });
    }
    
    if(num !== ""){
        document.getElementById('section').classList.remove('error');
        /*SECCIONES DE LABORATORIO*/
        this.waiting_modal.handleShow('Cargando...');
        fetch(Config.default.apiGateway.URL+"lab_sections"+(patient ? "/work_list_patient" : "")+"?lab_sections_id="+num+"&health_facilities_id="+sessionStorage.getItem("health_facilities_id")
          +'&start_date='+this.state.start_date+'&end_date='+this.state.end_date+'&start_folio='+this.state.start_folio+
          '&end_folio='+this.state.end_folio+'&filter='+this.state.filter_type+"&convoke_places_id="+this.state.convoke_places_id,{ 
          method: 'get',
          headers: new Headers({
            'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
            'Accept': 'application/json',
              'Content-Type': 'application/json',
          })
        })
        .then(res => {
          this.waiting_modal.handleClose();
              if(res.ok){
                return res.json();
              }else{
                res.text().then(function(error) {
                  swal('¡Error', error, 'error');
                });
            }
        })
        .then(response => {
          if(response !== undefined){
            this.table.setState({donations:response, pagination:[], select_section:false});
  
            setTimeout(function(){
              this.table.editValues();
  
            }.bind(this), 200);
  
            response.map((res)=>{
              if(patient){
                res.samples.map(s =>{
                  s.donation = {
                    id: s.samples_id,
                    donation_number: s.sample_number,
                  };

                  s.extraction_date = moment(s.sample_timestamp).format('DD/MM/YYYY');
                  s.donor_number = s.petition_number;
                  s.donor_name = s.patient_name;

                  return s;
                });

                res.donations = res.samples;
              }


              return this.table.paginator(res)
            })
          }
        })
    }else{
      swal('Error', 'Debe seleccionar una seccion', 'error');
      document.getElementById('section').classList.add('error');
    }
  
    
  }

  selectSection(){
    this.openModalSection();
  }

  cancel(){
    this.props.history.push('/');
  }

  //Contenido de la pantalla Listado
  render() {
    const { t } = this.props;
    var patient = false;
    if(this.props.location.pathname === '/work_list/patient'){
      patient = true;
    }

    return (
      <div className="col-xs-12">
        <div className="route">
            <h5 className="title_page" >
              {sessionStorage.getItem('health_facilities_name')} ->
              {t('sidebar.nav.laboratory.MAIN')} -> 
              {t('sidebar.nav.laboratory.work_list')+(patient ? ' de Pacientes': '')}
            </h5>
          </div>
          
        <Help 
            {...this.props}
            menu={"help_laboratory"} 
            submenu={"help_work_list"}  />
  
        <div className="form-group">
          <div className="col-xs-12 col-md-2">
            <span className="span-min">Sección</span>
            <select className="form-control" name="section" id="section" value={this.state.section} required
              onChange={this.handleChange}>
              <option value="">Seleccione...</option>
              {this.state.lab_sections.map((l, i)=>(
                <option key={i} value={l.lab_sections_id}>{l.name}</option>
              ))}
            </select>
          </div>
          <div className="col-xs-12 col-md-1">
            <span className="span-min">{t('content.validation_donation.start_date')+':'}</span>
            <input className="form-control hour-input" type="date" value={this.state.start_date} name="start_date" onChange={ this.handleChange}/>
          </div>
          <div className="col-xs-12 col-md-1">
            <span className="span-min">{t('content.validation_donation.end_date')+':'}</span>
            <input className="form-control hour-input" type="date" value={this.state.end_date} name="end_date" onChange={ this.handleChange}/>
          </div>

          <div className="col-xs-12 col-md-1">
            <span className="span-min">{t('content.validation_donation.start_folio')+':'}</span>
            <input className="form-control" type="text" value={this.state.start_folio} name="start_folio" onChange={ this.handleChange}/>
          </div>

          <div className="col-xs-12 col-md-1">
            <span className="span-min">{t('content.validation_donation.end_folio')+':'}</span>
            <input className="form-control" type="text" value={this.state.end_folio} name="end_folio" onChange={ this.handleChange}/>
          </div>

          <div className="col-xs-12 col-sm-2">
							<span className="span-min">{t('content.offers.form.convoke_place')}</span>
							<select className="form-control" 
				             	value={ this.state.convoke_places_id || "" } onKeyPress={(e) => this.props.validate(e)}
                       onChange={ this.handleChange} name="convoke_places_id" id="convoke_places_id" >
                        {this.state.convoke_places.length !== 1 && (
                          <option value="all" key="all">TODOS</option>
                        )}
				                {
				                this.state.convoke_places.map(function(t) {
				                  return <option key={t.convoke_places.id}  value={t.convoke_places.id} >{t.convoke_places.name} </option>;
				                })
				            }
              </select>
          </div>	

          <div className="col-xs-12 col-md-2" style={{paddingTop:"20px"}}> 
            <select className="form-control" onChange={ this.handleChange }
                value={ this.state.filter_type || "" } 
                  name="filter_type" id="filter_type" >
                  {
                  this.state.filters.map(function(t) {
                    return <option key={t.key}  value={t.key} >{t.value} </option>;
                  })
              }
            </select>
          </div>

          <div className="col-xs-12 col-sm-1 form-group" style={{paddingTop:"12px"}}>
            <button style={{float:"right", fontSize:"1em"}} className="btn btn-info" onClick={(e)=>this.getSections(this.state.lab_sections_id)} type="button">{t('content.generics.buttons.search')}</button>
          </div>

        </div>
        
        <div >
          <TableWorkList {...this.props} onRef={ref => (this.table = ref)} state={this.state} />
      
          <div className="col-xs-12" style={{textAlign:"center"}}>
            <RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.saveItem} style={style}/>
            <RaisedButton className="action-btn" label={t('content.generics.buttons.reset')} primary={true} onClick={this.cancel} style={style}/>
          </div>
        </div>
        
        <Notifications />
        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)} />
        <ModalSection {...this.props} onRef={ref => (this.modal_section = ref)} getSections={this.getSections} state={this.state} />
      </div>
    );
  }
}

export default translate('translations')(WorkList)